import { hasSecretInPath } from './secretRoutes';

const PIXEL_ID = '2002970200343069';
const SCRIPT_ID = 'meta-pixel';
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

let initialized = false;
let lastPageViewUrl = null;

function createFbq() {
  if (window.fbq) return window.fbq;

  const fbq = function(...args) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  };

  window.fbq = fbq;
  window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  return fbq;
}

export function enableMetaPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const fbq = createFbq();

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = SCRIPT_SRC;
    document.head.appendChild(script);
  }

  if (!initialized) {
    fbq('init', PIXEL_ID);
    initialized = true;
  }

  fbq('consent', 'grant');
  trackMetaPageView();
}

export function disableMetaPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (window.fbq) {
    window.fbq('consent', 'revoke');
  }

  const script = document.getElementById(SCRIPT_ID);
  if (script) script.remove();
  lastPageViewUrl = null;
}

export function trackMetaPageView() {
  if (typeof window === 'undefined' || !window.fbq || !initialized) return;
  if (hasSecretInPath()) return;

  const pageUrl = window.location.href;
  if (pageUrl === lastPageViewUrl) return;

  window.fbq('track', 'PageView');
  lastPageViewUrl = pageUrl;
}
